<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <iframe
            src="/proxy/sgucs/"
            style="width: 100%; height: 100%; border: 0px;"
            :style="`min-height: ${height}`"
          ></iframe>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import MixinStorage from "@/mixins/storage";

export default {
  name: "PaprikaDiseaseAnalysis",
  components: {},
  mixins: [MixinStorage("disease")],
  data() {
    return {
      height: "500px",
    };
  },
  mounted() {
    this.$nextTick(async () => {
      window.addEventListener("resize", this.resizeEvent);
      this.resizeEvent();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEvent);
  },
  methods: {
    resizeEvent() {
      const el = document.documentElement;
      this.height = el.clientHeight - 200 + "px";
      console.log("height : ", this.height);
    },
  },
};
</script>
